// vue3-migration -- Element
import langRu from 'element-plus/es/locale/lang/ru';
import translations from './translations.json';
import 'moment/locale/ru';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langRu,
};
